var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _g4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 249,
    viewBox: "0 0 252 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.022 249C187.916 249 238.09 196.963 238.09 132.771C238.09 68.5797 187.916 16.5422 126.022 16.5422C64.1283 16.5422 13.9536 68.5797 13.9536 132.771C13.9536 196.963 64.1283 249 126.022 249Z",
    fill: "url(#paint0_linear_899_567)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.483 43.5891H62.3347C54.5964 43.5891 48.3232 50.0951 48.3232 58.1208H200.494C200.494 50.0951 194.221 43.5891 186.483 43.5891Z",
    fill: "url(#paint1_linear_899_567)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3232 57.7239H200.494V177.923C200.494 183.267 198.447 188.392 194.804 192.171C191.16 195.95 186.218 198.073 181.066 198.073H67.7519C62.5991 198.073 57.6574 195.95 54.0138 192.171C50.3702 188.392 48.3232 183.267 48.3232 177.923V57.7239Z",
    fill: "url(#paint2_linear_899_567)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.337 72.9048H74.5301C72.4516 72.9048 70.7666 74.6505 70.7666 76.8038C70.7666 78.9572 72.4516 80.7029 74.5301 80.7029H174.337C176.416 80.7029 178.101 78.9572 178.101 76.8038C178.101 74.6505 176.416 72.9048 174.337 72.9048Z",
    fill: "url(#paint3_linear_899_567)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.337 106.036H74.5301C72.4516 106.036 70.7666 107.782 70.7666 109.935C70.7666 112.089 72.4516 113.834 74.5301 113.834H174.337C176.416 113.834 178.101 112.089 178.101 109.935C178.101 107.782 176.416 106.036 174.337 106.036Z",
    fill: "url(#paint4_linear_899_567)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.337 139.168H74.5301C72.4516 139.168 70.7666 140.914 70.7666 143.068C70.7666 145.221 72.4516 146.967 74.5301 146.967H174.337C176.416 146.967 178.101 145.221 178.101 143.068C178.101 140.914 176.416 139.168 174.337 139.168Z",
    fill: "url(#paint5_linear_899_567)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.337 172.298H74.5301C72.4516 172.298 70.7666 174.044 70.7666 176.197C70.7666 178.351 72.4516 180.096 74.5301 180.096H174.337C176.416 180.096 178.101 178.351 178.101 176.197C178.101 174.044 176.416 172.298 174.337 172.298Z",
    fill: "url(#paint6_linear_899_567)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_899_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8526 132.061H20.7068C16.4372 132.061 12.9761 135.651 12.9761 140.079V218.862C12.9761 223.291 16.4372 226.88 20.7068 226.88H73.8526C78.1222 226.88 81.5834 223.291 81.5834 218.862V140.079C81.5834 135.651 78.1222 132.061 73.8526 132.061Z",
    fill: "url(#paint7_linear_899_567)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_899_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.142 9H166.44C163.705 9 161.487 11.2998 161.487 14.1368V42.7523C161.487 45.5892 163.705 47.889 166.44 47.889H225.142C227.877 47.889 230.095 45.5892 230.095 42.7523V14.1368C230.095 11.2998 227.877 9 225.142 9Z",
    fill: "url(#paint8_linear_899_567)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9227 171.474H26.6378C25.2476 171.474 24.1206 172.642 24.1206 174.084V174.093C24.1206 175.535 25.2476 176.703 26.6378 176.703H67.9227C69.3129 176.703 70.4399 175.535 70.4399 174.093V174.084C70.4399 172.642 69.3129 171.474 67.9227 171.474Z",
    fill: "url(#paint9_linear_899_567)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9457 208.272H27.0156C25.6373 208.272 24.52 209.405 24.52 210.802V210.81C24.52 212.207 25.6373 213.339 27.0156 213.339H67.9457C69.324 213.339 70.4412 212.207 70.4412 210.81V210.802C70.4412 209.405 69.324 208.272 67.9457 208.272Z",
    fill: "url(#paint10_linear_899_567)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9457 189.02H27.0156C25.6373 189.02 24.52 190.153 24.52 191.549V191.558C24.52 192.955 25.6373 194.087 27.0156 194.087H67.9457C69.324 194.087 70.4412 192.955 70.4412 191.558V191.549C70.4412 190.153 69.324 189.02 67.9457 189.02Z",
    fill: "url(#paint11_linear_899_567)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.732 144.227H29.6675C26.995 144.227 24.8286 146.474 24.8286 149.245V152.718C24.8286 155.489 26.995 157.736 29.6675 157.736H41.732C44.4044 157.736 46.5708 155.489 46.5708 152.718V149.245C46.5708 146.474 44.4044 144.227 41.732 144.227Z",
    fill: "url(#paint12_linear_899_567)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.979 34.3456C179.124 34.3456 181.673 31.7016 181.673 28.44C181.673 25.1784 179.124 22.5344 175.979 22.5344C172.834 22.5344 170.285 25.1784 170.285 28.44C170.285 31.7016 172.834 34.3456 175.979 34.3456Z",
    fill: "#958DF1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.328 34.3456C199.473 34.3456 202.023 31.7016 202.023 28.44C202.023 25.1784 199.473 22.5344 196.328 22.5344C193.184 22.5344 190.634 25.1784 190.634 28.44C190.634 31.7016 193.184 34.3456 196.328 34.3456Z",
    fill: "#958DF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.678 34.3456C219.822 34.3456 222.372 31.7016 222.372 28.44C222.372 25.1784 219.822 22.5344 216.678 22.5344C213.533 22.5344 210.983 25.1784 210.983 28.44C210.983 31.7016 213.533 34.3456 216.678 34.3456Z",
    fill: "#958DF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.236 175.201L186.814 191.69L227.464 229.931L241.885 213.441L201.236 175.201Z",
    fill: "url(#paint13_linear_899_567)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.478 147.91C216.478 182.406 189.514 210.371 156.253 210.371C122.991 210.371 96.0278 182.406 96.0278 147.91C96.0278 113.414 122.991 85.4495 156.253 85.4495C189.514 85.4495 216.478 113.414 216.478 147.91ZM207.239 147.91C207.239 177.115 184.411 200.79 156.252 200.79C128.092 200.79 105.265 177.115 105.265 147.91C105.265 118.705 128.092 95.03 156.252 95.03C184.411 95.03 207.239 118.705 207.239 147.91Z",
    fill: "url(#paint14_linear_899_567)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_899_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.251 200.789C184.411 200.789 207.238 177.114 207.238 147.91C207.238 118.705 184.411 95.0295 156.251 95.0295C128.092 95.0295 105.264 118.705 105.264 147.91C105.264 177.114 128.092 200.789 156.251 200.789Z",
    fill: "url(#paint15_linear_899_567)",
    fillOpacity: 0.2
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.503 147.91L183.085 132.753C184.451 131.254 185.199 129.261 185.171 127.198C185.143 125.135 184.34 123.165 182.934 121.707C181.527 120.248 179.628 119.416 177.639 119.386C175.65 119.357 173.728 120.133 172.283 121.55L157.668 136.707L143.087 121.55C142.385 120.78 141.542 120.164 140.606 119.737C139.671 119.311 138.663 119.084 137.641 119.069C136.619 119.054 135.605 119.252 134.659 119.65C133.712 120.049 132.852 120.64 132.13 121.389C131.407 122.138 130.837 123.03 130.453 124.012C130.068 124.994 129.878 126.046 129.892 127.105C129.907 128.165 130.126 129.21 130.537 130.181C130.948 131.151 131.542 132.025 132.285 132.753L146.891 147.91L132.285 163.067C131.542 163.795 130.948 164.669 130.537 165.639C130.126 166.61 129.907 167.655 129.892 168.715C129.878 169.774 130.068 170.826 130.453 171.808C130.837 172.79 131.407 173.681 132.13 174.431C132.852 175.18 133.712 175.771 134.659 176.17C135.605 176.568 136.619 176.766 137.641 176.751C138.663 176.736 139.671 176.509 140.606 176.082C141.542 175.656 142.385 175.04 143.087 174.27L157.701 159.113L172.315 174.27C173.775 175.603 175.669 176.309 177.613 176.243C179.557 176.178 181.404 175.346 182.777 173.918C184.15 172.49 184.947 170.572 185.004 168.556C185.061 166.539 184.374 164.576 183.085 163.067L168.503 147.91Z",
    fill: "url(#paint16_linear_899_567)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_899_567)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.937,
    cy: 177.117,
    rx: 35.8433,
    ry: 5.49161,
    fill: "#EC5575",
    fillOpacity: 0.56
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.461 213.813C116.966 211.646 120.05 211.646 120.554 213.813L122.208 220.921C122.387 221.688 122.98 222.291 123.745 222.483L130.895 224.273C133.016 224.804 133.016 227.818 130.895 228.349L123.745 230.139C122.98 230.331 122.387 230.934 122.208 231.701L120.554 238.809C120.05 240.976 116.966 240.976 116.461 238.809L114.807 231.701C114.628 230.934 114.035 230.331 113.271 230.139L106.12 228.349C103.999 227.818 103.999 224.804 106.12 224.273L113.271 222.483C114.035 222.291 114.628 221.688 114.807 220.921L116.461 213.813Z",
    fill: "url(#paint17_linear_899_567)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3661 19.2545C35.8703 17.0882 38.9545 17.0882 39.4588 19.2545L41.1132 26.3628C41.2919 27.1303 41.8849 27.7333 42.6493 27.9246L49.7996 29.7148C51.9207 30.2458 51.9207 33.26 49.7996 33.791L42.6493 35.5812C41.8849 35.7725 41.2919 36.3755 41.1132 37.143L39.4588 44.2513C38.9545 46.4176 35.8703 46.4176 35.3661 44.2513L33.7116 37.143C33.533 36.3755 32.9399 35.7725 32.1755 35.5812L25.0252 33.791C22.9042 33.26 22.9042 30.2458 25.0252 29.7148L32.1755 27.9246C32.9399 27.7333 33.533 27.1303 33.7116 26.3628L35.3661 19.2545Z",
    fill: "url(#paint18_linear_899_567)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.553 20.2207C123.443 20.2207 124.975 18.632 124.975 16.6723C124.975 14.7126 123.443 13.1239 121.553 13.1239C119.664 13.1239 118.132 14.7126 118.132 16.6723C118.132 18.632 119.664 20.2207 121.553 20.2207ZM121.553 22.882C124.86 22.882 127.541 20.1018 127.541 16.6723C127.541 13.2428 124.86 10.4626 121.553 10.4626C118.247 10.4626 115.566 13.2428 115.566 16.6723C115.566 20.1018 118.247 22.882 121.553 22.882Z",
    fill: "url(#paint19_linear_899_567)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M227.945 117.944C227.618 116.614 228.802 115.415 230.076 115.786L238.607 118.273C239.88 118.644 240.288 120.305 239.341 121.264L232.999 127.683C232.052 128.642 230.461 128.179 230.134 126.85L227.945 117.944Z",
    fill: "url(#paint20_linear_899_567)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3412 102.696C28.6234 102.359 29.7756 103.586 29.4162 104.906L27.0078 113.751C26.6481 115.072 25.0444 115.495 24.1217 114.512L17.9407 107.927C17.0181 106.944 17.4688 105.292 18.7519 104.955L27.3412 102.696Z",
    fill: "url(#paint21_linear_899_567)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.507 225.309C191.789 224.971 192.942 226.199 192.582 227.519L190.174 236.364C189.814 237.685 188.21 238.108 187.288 237.125L181.107 230.539C180.184 229.556 180.635 227.905 181.918 227.568L190.507 225.309Z",
    fill: "url(#paint22_linear_899_567)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.87 71.9001C237.759 71.9001 239.291 70.3115 239.291 68.3517C239.291 66.392 237.759 64.8034 235.87 64.8034C233.98 64.8034 232.448 66.392 232.448 68.3517C232.448 70.3115 233.98 71.9001 235.87 71.9001ZM235.87 74.5614C239.176 74.5614 241.857 71.7812 241.857 68.3517C241.857 64.9222 239.176 62.1421 235.87 62.1421C232.563 62.1421 229.882 64.9222 229.882 68.3517C229.882 71.7812 232.563 74.5614 235.87 74.5614Z",
    fill: "url(#paint23_linear_899_567)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M227.46 229.934L241.882 213.445L244.054 215.488C246.162 217.471 247.423 220.241 247.562 223.188C247.7 226.136 246.704 229.02 244.793 231.205C242.881 233.391 240.21 234.7 237.368 234.843C234.526 234.987 231.746 233.954 229.638 231.971L227.466 229.928L227.46 229.934Z",
    fill: "#9991EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_899_567",
    x: 0.976074,
    y: 124.061,
    width: 98.6074,
    height: 124.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_899_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_899_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_899_567",
    x: 154.487,
    y: 0,
    width: 94.6074,
    height: 64.8892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_899_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_899_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_899_567",
    x: 88.589,
    y: 78.3544,
    width: 135.324,
    height: 139.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8.33757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_899_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_899_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_899_567",
    x: 101.25,
    y: 150.781,
    width: 113.374,
    height: 52.671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.422,
    result: "effect1_foregroundBlur_899_567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_567",
    x1: 125.158,
    y1: -21.3047,
    x2: 127.627,
    y2: 386.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#857AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_899_567",
    x1: 48.1509,
    y1: 46.9428,
    x2: 200.623,
    y2: 57.3092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_899_567",
    x1: 43.7542,
    y1: 162.968,
    x2: 263.595,
    y2: 166.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_899_567",
    x1: 66.227,
    y1: 80.3813,
    x2: 184.45,
    y2: 80.3813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECCEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_899_567",
    x1: 66.227,
    y1: 113.513,
    x2: 184.45,
    y2: 113.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECCEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_899_567",
    x1: 66.227,
    y1: 146.645,
    x2: 184.45,
    y2: 146.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECCEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_899_567",
    x1: 66.227,
    y1: 179.775,
    x2: 184.45,
    y2: 179.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECCEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_899_567",
    x1: 10.9161,
    y1: 203.164,
    x2: 142.476,
    y2: 213.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABA5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_899_567",
    x1: 159.427,
    y1: 38.162,
    x2: 258.496,
    y2: 40.9252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_899_567",
    x1: 75.8154,
    y1: 176.859,
    x2: 20.1237,
    y2: 176.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_899_567",
    x1: 75.7705,
    y1: 213.49,
    x2: 20.5575,
    y2: 213.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_899_567",
    x1: 75.7705,
    y1: 194.238,
    x2: 20.5575,
    y2: 194.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_899_567",
    x1: 61.6474,
    y1: 157.606,
    x2: 22.0769,
    y2: 157.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243799,
    stopColor: "#E4E3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_899_567",
    x1: 196.179,
    y1: 200.534,
    x2: 211.318,
    y2: 184.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_899_567",
    x1: 95.8914,
    y1: 114.28,
    x2: 217.133,
    y2: 115.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_899_567",
    x1: 156.251,
    y1: 95.0295,
    x2: 210.98,
    y2: 231.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_899_567",
    x1: 130.156,
    y1: 122.949,
    x2: 187.397,
    y2: 174.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF698D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_899_567",
    x1: 97.933,
    y1: 214.848,
    x2: 139.259,
    y2: 215.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_899_567",
    x1: 16.8378,
    y1: 20.2896,
    x2: 58.1639,
    y2: 20.5483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_899_567",
    x1: 115.552,
    y1: 13.3288,
    x2: 127.606,
    y2: 13.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_899_567",
    x1: 223.831,
    y1: 124.091,
    x2: 236.666,
    y2: 112.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_899_567",
    x1: 21.4158,
    y1: 98.4228,
    x2: 33.7995,
    y2: 110.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_899_567",
    x1: 184.582,
    y1: 221.036,
    x2: 196.965,
    y2: 233.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_899_567",
    x1: 229.869,
    y1: 65.0083,
    x2: 241.922,
    y2: 65.0837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7166E7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.ebb104ac.svg";
export { ForwardRef as ReactComponent };